export default {
    all: []
}



// WEBPACK FOOTER //
// ./src/modules/parameters/product_categories/store/state.js